// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CountInput_wrapper__23yNF","s":"CountInput_s__YzKsy","m":"CountInput_m__2ai9L","button":"CountInput_button__zdQHy","disabled":"CountInput_disabled__txhLu"};